export default {"src":"/_next/static/media/WhoWeAre_024A.62794c26.JPG","height":694,"width":1920};